@if (visible()) {
  <div
    class="toast"
    [class.toast-leaving]="dismissing()"
    [class.toast--error]="type() === 'error'"
    [style.bottom]="offsetY()"
    [style.left]="centerX()"
    role="alert"
    aria-live="assertive"
    aria-atomic="true"
  >
    <span class="toast-text">{{ text() }}</span>
    @if (isDismissable()) {
      <button
        class="toast-dismiss"
        (click)="dismiss()"
        aria-label="Dismiss notification"
      >
        ✕
      </button>
    }
  </div>
}
